import { Action } from 'redux'
import { ProvenancesActions } from '../../reducers/provenances/actionNames'

export const deleteProvenance = (
  provenanceId: number,
): IRequestDeleteProvenance => ({
  provenanceId,
  type: ProvenancesActions.RequestDeleteProvenance,
})

export const deletedProvenance = (
  provenanceId: number,
): IDeletedProvenance => ({
  provenanceId,
  type: ProvenancesActions.DeletedProvenance,
})

export const rejectDeleteProvenance = (
  errMessage: string,
): IRejectDeleteProvenance => ({
  errMessage,
  type: ProvenancesActions.ProvenanceDeleteAreRejected,
})

export interface IRequestDeleteProvenance
  extends Action<ProvenancesActions.RequestDeleteProvenance> {
  provenanceId: number
}

export interface IDeletedProvenance
  extends Action<ProvenancesActions.DeletedProvenance> {
  provenanceId: number
}

export interface IRejectDeleteProvenance
  extends Action<ProvenancesActions.ProvenanceDeleteAreRejected> {
  errMessage: string
}
